import { getLocalStorage } from "global/utils/safeJsonParse";

export const mantenimientoTitulo = "Sitio en Mantenimiento"
const config = getLocalStorage("config", {});
let mantenimientoMsj = config?.mantenimientoMsj;



export const mantenimientoDescripcion = mantenimientoMsj ? mantenimientoMsj :`
En este momento estamos trabajando en el sitio web para poder 
seguir brindando el mejor servicio posible.
Le pedimos disculpas por cualquier molestia ocasionada.`;
  